
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import dynamic from 'next/dynamic';
import useLocale from 'next-translate/useTranslation';
import { useEffect, useState } from 'react';
import NarrowDashboardLayout from '@/components/layout/NarrowDashboardLayout';
import Seo from '@/components/Seo';
import AuthModal from '@/components/AuthModal';
import Spinner from '@/components/Spinner';
import { useUser } from '@/utils/useUser';
const ProjectList = dynamic(() => import('@/components/video-editor/VideoEditor').then((mod) => mod.ProjectList), { ssr: false });
const VideoEditor = dynamic(() => import('@/components/video-editor/VideoEditor'), { ssr: false });
function SampleProjectEditor() {
    const { t } = useLocale('common');
    const [sampleId, setSampleId] = useState<string | null>(null);
    const [showAuth, setShowAuth] = useState(false);
    useEffect(() => {
        let cancelled = false;
        (async () => {
            const { cloneSampleTemplate } = await import('@/components/video-editor/templates/sample-video-ad');
            const { useVideoEditorStore } = await import('@/components/video-editor/store');
            const { project, tracks, keyFrames, mediaItems } = cloneSampleTemplate();
            const store = useVideoEditorStore.getState();
            store.setProject(project);
            store.setTracks(tracks);
            store.setKeyFrames(keyFrames);
            store.setMediaItems(mediaItems);
            store.setIsReadOnly(true);
            if (!cancelled)
                setSampleId(project.id);
        })();
        return () => {
            cancelled = true;
            import('@/components/video-editor/store').then(({ useVideoEditorStore }) => {
                const store = useVideoEditorStore.getState();
                store.setIsReadOnly(false);
                store.setProject(null);
            });
        };
    }, []);
    if (!sampleId) {
        return (<div className='flex min-h-screen items-center justify-center bg-gray-950'>
        <Spinner className='h-8 w-8'/>
      </div>);
    }
    return (<>
      <VideoEditor projectId={sampleId}/>
      <div className='fixed top-3 right-4 z-50'>
        <button onClick={() => setShowAuth(true)} className='rounded-lg bg-primary-600 px-4 py-2 text-sm font-semibold text-white shadow-lg transition-all hover:bg-primary-700'>
          {t('Sign up')}
        </button>
      </div>
      <AuthModal showModal={showAuth} onClose={() => setShowAuth(false)} redirectTo='/ai-video-editor'/>
    </>);
}
const AIVideoEditorPage = () => {
    const { t } = useLocale('common');
    const { user } = useUser();
    return (<NarrowDashboardLayout showMobileMenu={!!user} sidebarVisible={!!user}>
      <main className='flex-1 overflow-y-auto bg-gray-950 focus:outline-none'>
        <Seo templateTitle={t('AI Video Editor')} description={t('Create professional videos with AI-generated content - video, images, music, voiceovers, and sound effects')}/>
        {user ? <ProjectList /> : <SampleProjectEditor />}
      </main>
    </NarrowDashboardLayout>);
};
export default AIVideoEditorPage;

    async function __Next_Translate__getStaticProps__1a0cbfb65e3__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/ai-video-editor/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a0cbfb65e3__ as getStaticProps }
  